import type { TFunction } from 'i18next';

import { ListFiltersBar, type SelectMenuOption } from '@/shared/ui';

import type { OrderListSortBy } from '../types';

export interface OrderFiltersBarProps {
  t: TFunction<'orders'>;
  query: string;
  onQueryChange: (next: string) => void;
  statusFilter: string;
  statusOptions: SelectMenuOption[];
  onStatusFilterChange: (next: string) => void;
  sortBy: OrderListSortBy;
  sortOptions: Array<{ value: OrderListSortBy; label: string }>;
  onSortByChange: (next: OrderListSortBy) => void;
}

export function OrderFiltersBar({
  t,
  query,
  onQueryChange,
  statusFilter,
  statusOptions,
  onStatusFilterChange,
  sortBy,
  sortOptions,
  onSortByChange,
}: OrderFiltersBarProps) {
  return (
    <ListFiltersBar
      ariaLabel={t('filters.aria')}
      searchId="orders-search"
      searchLabel={t('filters.searchLabel')}
      searchPlaceholder={t('filters.searchPlaceholder')}
      query={query}
      onQueryChange={onQueryChange}
      filterLabel={t('filters.filter')}
      filterSectionLabel={t('filters.statusSectionLabel')}
      filterValue={statusFilter}
      filterDefaultValue="all"
      filterOptions={statusOptions}
      onFilterChange={onStatusFilterChange}
      sortLabel={t('filters.sortBy')}
      sortValue={sortBy}
      sortOptions={sortOptions}
      onSortChange={onSortByChange}
    />
  );
}
